import React from 'react'
import { Navigate } from 'react-router-dom'

// Holds the route until the caller knows the user's roles, so an admin landing
// directly on the page isn't redirected away before their roles arrive.
// Callers must not pass a disabled query's `isLoading` as `isResolving`: on
// react-query v4 that stays true forever and would hang the route.
//
// Defense in depth only — the endpoint behind an admin-only page is the real
// gate and answers 403 to non-admins.
const AdminOnly = ({ isAllowed, isResolving, redirectTo, children }) => {
  if (isResolving) return null

  return isAllowed ? children : <Navigate to={redirectTo} replace />
}

export default AdminOnly
